import React, { useState } from "react";
import { useSelector } from 'react-redux'
import NavButton from './NavButton'
import { Link } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import MobileNav from "./MobileNav";
import logo from "../../assets/images/healthify-logo.png";
import { CaretDownFilled } from "@ant-design/icons"
import NavSearch from "./NavSearch";
import "antd/dist/antd.css";
import { Menu, Dropdown } from "antd";

function Header() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const isToken = useSelector((state) => state.auth.isToken);
  const [mobileNav, setMobileNav] = useState(false);
  const [expand, setExpand] = useState(false);

  const handleExpand = () => {
    setExpand(!expand);
  };
  const menu = (
    <Menu onClick={handleExpand}>
      <Menu.Item key="1">
        <Link to="/coming-soon">Need medical advise? Talk to a Doctor</Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to="/coming-soon">Call an Ambulance near your location</Link>
      </Menu.Item>
    </Menu>
  );

  const NavClass = () => {
    setMobileNav(!mobileNav);
  };

  return (
    <header className="header">
      {mobileNav && <MobileNav mobileNav={mobileNav} setMobileNav={NavClass} />}
      {/* <MobileNav mobileNav={mobileNav} setMobileNav={NavClass} /> */}
      <div className="header__nav">
        <Link to="/">
          <span className="header__nav__logo">
            <img src={logo} alt="" /> Healthify
          </span>
        </Link>

        <div className="header__nav__items">
          <Dropdown overlay={menu}>
            <Link to="/coming-soon">
              Features{" "}
              <span style={{ marginLeft: '4px' }}>
                <CaretDownFilled />{" "}
              </span>
            </Link>
          </Dropdown>

          <Link to="/about">About</Link>
          <Link to="/coming-soon">Contact</Link>
        </div>
      </div>
      { isAuthenticated && isToken ? <NavSearch /> : <NavButton />}
      <div
        className="mobile-nav-toggle__open "
        onClick={() => NavClass()}
        onKeyDown={() => NavClass()}
        role="button"
        tabIndex="0"
      >
        <MenuIcon className="icon-img" fontSize="large" />
      </div>
    </header>
  );
}
export default Header;
